import React from 'react';
import TemplatePage from '../../../components/templatePage';
import GamerItem from '../../components/gamerItem';
import { useDispatch, useSelector } from 'react-redux';
import { setGetUsers } from '../../../../desktop/users/store/thunk/setGetUsers';
import { makeStyles } from '@material-ui/core';
import { useForm, useWatch } from 'react-hook-form';
import Title from '../../../../../@casino/ui/title';
import CheckboxSwitch from '../../../../desktop/users/components/CheckboxSwitch';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        paddingTop: 0
    },
    wrapBlock: {
        padding: 20,
        background: '#1b2039',
        borderRadius: 8,
        marginBottom: 12,
    },
    loginGamer: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        width: 'calc(100% - 23px)'
    },
}))

const UserList = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [page, setPage] = React.useState(1)
    const {
        register,
        handleSubmit,
        reset,
        control
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            stream: '',
            login: '',
            phone: '',
            email: '',
            is_deposit: false
        }
    })

    const view = useSelector(state => state.auth.admin);

    React.useEffect(() => {
        if (view?.login && view?.role !== 'support') {
            dispatch(setGetUsers({
                page: 1,
                rowsPerPage: 10
            }));
        }
    }, [view]);

    const onSubmit = (store) => {
        if (store.login || store.email || store.stream || store.phone || store.referral || store.from_register || store.to_register || store.count_deposit || store.sum_deposit) {
            dispatch(setGetUsers({
                page: 1,
                rowsPerPage: 10,
                login: store.login,
                stream: store.stream,
                email: store.email,
                phone: store.phone,
                from_register: store.from_register,
                to_register: store.to_register,
                count_deposit: store.is_deposit ? store.count_deposit : undefined,
                sum_deposit: store.is_deposit ? store.sum_deposit : undefined
            }))
        }
    }

    const users = useSelector(state => state.users.list);

    const [email, login, stream, phone, is_deposit, count_deposit, sum_deposit, from_register, to_register] = useWatch({
        control,
        name: ['email', 'login', 'stream', 'phone', 'is_deposit', 'count_deposit', 'sum_deposit', 'from_register', 'to_register']
    })

    return (
        <div className={classes.root}>
            <Title label="Список игроков" />
            <form onSubmit={handleSubmit(onSubmit)} className={classes.wrapBlock} style={{ padding: 0, display: 'flex', flexDirection: 'column', paddingBottom: 20, rowGap: 10, padding: 10 }}>
                <label htmlFor="login">
                    <input
                        {...register('login')}
                        type="text"
                        id="login"
                        className={classes.loginGamer}
                        placeholder="Поиск по логину"
                    />
                </label>
                {
                    view?.role !== 'support' && (
                        <label htmlFor="phone">
                            <input
                                {...register('phone')}
                                type="text"
                                id="phone"
                                className={classes.loginGamer}
                                placeholder="Поиск по номеру телефона"
                            />
                        </label>
                    )
                }
               
                <label htmlFor="email">
                    <input
                        {...register('email')}
                        type="text"
                        id="email"
                        className={classes.loginGamer}
                        placeholder="Поиск по email"
                    />
                </label>
                <label htmlFor="stream">
                    <input
                        {...register('stream')}
                        type="text"
                        id="stream"
                        className={classes.loginGamer}
                        placeholder="Поиск по stream"
                    />
                </label>
                {
                        view?.role !== 'support' && (
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 12 }}>
                                <div>
                                    <span style={{color: '#FFF', fontFamily: 'Calibri, sans-serif'}}>Период регистрации</span>
                                </div>
                                <div style={{display: 'flex', flexDirection: 'column', rowGap: 12}}> 
                                    <input
                                        {...register('from_register')}
                                        type={'datetime-local'}
                                        style={{ border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff', height: 30 }}
                                    />
                                    <input
                                        {...register('to_register')}
                                        type={'datetime-local'}
                                        style={{ border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff', height: 30 }}
                                    />
                                </div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', rowGap: 12}}> 
                                <CheckboxSwitch
                                    register={register}
                                    control={control}
                                    name="is_deposit"
                                    label="Имеются депозиты"
                                />
                                {
                                    is_deposit && (
                                        <label htmlFor="count_deposit">
                                            <input
                                                {...register('count_deposit')}
                                                type="number"
                                                id="count_deposit"
                                                className={classes.loginGamer}
                                                placeholder="Кол-во депозитов от"
                                            />
                                        </label>
                                    )
                                }
                                {
                                    is_deposit && (
                                        <label htmlFor="sum_deposit">
                                            <input
                                                {...register('sum_deposit')}
                                                type="number"
                                                id="sum_deposit"
                                                className={classes.loginGamer}
                                                placeholder="Сумма депозитов от"
                                            />
                                        </label>
                                    )
                                }
                            </div>
                            
                        </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button type="submit" style={{
                        color: '#141b33',
                        cursor: 'pointer',
                        padding: '10px 0',
                        //  width: 'calc(100% - 25px)',
                        width: '100%',
                        background: '#ffc324',
                        borderRadius: '4px',
                        border: 'none',
                        outline: 'none'
                    }}>Поиск</button>
                </div>
            </form>
            {
                users.data.map((item) => (
                    <div className={classes.wrapBlock}>
                        <GamerItem item={item} />
                    </div>))
            }
            {
                view?.role !== 'support' && (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button type="button" onClick={() => {
                            dispatch(setGetUsers({
                                page: 1,
                                rowsPerPage: (page + 1) * 10,
                                login,
                                stream,
                                email,
                                phone,
                                count_deposit, 
                                sum_deposit, 
                                from_register, 
                                to_register
                            }))
                            setPage(page + 1)
                        }} style={{
                            color: '#141b33',
                            cursor: 'pointer',
                            padding: '10px 0',
                            //  width: 'calc(100% - 25px)',
                            width: '100%',
                            background: '#ffc324',
                            borderRadius: '4px',
                            border: 'none',
                            outline: 'none'
                        }}>Показать еще</button>
                    </div>
                )
            }
        </div>
    )
}

export default UserList;